// Counter mechanic (SC-H3, design §3). Raised tap button; number bumps per tap; sets>1 runs per
// set with dots + a between-set toast. Unit label from measure_unit (default reps).
const T = (k, p) => window.HUD?.T?.(k, p) || k;

export const counter = {
  key: 'counter',
  matches: e => !!e.reps,
  render(host, e, ctx) {
    const reps = e.reps, sets = e.sets || 1, tint = ctx.tint || 'mint';
    const unit = e.measure_unit || T('hw3_reps_label');
    let n = 0, setIdx = 0, done = false;

    host.innerHTML =
      `<button type="button" class="hwp-tapbtn t-${tint}"><span class="n">0</span>` +
      `<span class="l">${T('hw5_tap_each', { n: reps })}</span></button>` +
      (sets > 1
        ? `<div class="hwp-setdots">${Array.from({ length: sets }, (_, i) => `<i class="${i === 0 ? 'cur' : ''}"></i>`).join('')}</div><div class="hwp-sublabel">${T('hw5_set_k_of_n', { k: 1, n: sets })}</div>`
        : `<div class="hwp-sublabel">${T('hw5_n_and_done', { n: reps, unit })}</div>`);

    const btn = host.querySelector('.hwp-tapbtn');
    const numEl = btn.querySelector('.n');
    const label = btn.querySelector('.l');
    const dots = host.querySelector('.hwp-setdots');
    const sub = host.querySelector('.hwp-sublabel');

    btn.onclick = () => {
      if (done) return;
      n++;
      numEl.textContent = String(n);
      numEl.classList.remove('bump'); void numEl.offsetWidth; numEl.classList.add('bump');
      if (navigator.vibrate) { try { navigator.vibrate(12); } catch (_) {} }
      label.textContent = T('hw5_tap_each', { n: Math.max(0, reps - n) });
      if (n >= reps) {
        setIdx++;
        if (dots && dots.children[setIdx - 1]) { dots.children[setIdx - 1].classList.add('on'); dots.children[setIdx - 1].classList.remove('cur'); }
        if (setIdx >= sets) { done = true; setTimeout(() => ctx.onFinish({ actual_value: reps * sets }), 350); return; }
        if (dots && dots.children[setIdx]) dots.children[setIdx].classList.add('cur');
        n = 0;
        setTimeout(() => { numEl.textContent = '0'; if (sub) sub.textContent = T('hw5_set_k_of_n', { k: setIdx + 1, n: sets }); label.textContent = T('hw5_tap_each', { n: reps }); }, 260);
        ctx.toast && ctx.toast(T('hw5_set_done', { k: setIdx, n: sets - setIdx }));
      }
    };

    return { stop() {} };
  },
  summary(res) { return res && res.actual_value ? String(res.actual_value) : ''; },
};
